"use client";
import { useEffect } from "react";
import H from "./components/Home";
import Tab from "./components/Tab";
import Product from "./components/Product";
import Campus from "./components/Campus";
import Advantage from "./components/Advantage";
import Partner from "./components/Partner";
import Teacher from "./components/Teacher";
import Message from "./components/Message";
import Log from "../components/Log";

export default function Home() {
  useEffect(() => {
    // 检查 hash
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        // 这里可以加偏移量
        const offset = 90;
        const top =
          el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top, behavior: "smooth" });
      }
    }
  }, []);
  return (
    <div className="flex flex-col min-h-screen">
      {/* 注意：Header 可能已经在 layout.tsx 中引入，这里可以不需要 */}
      {/* <Header /> */}
      <H />
      <Tab />
      <div id="services">
        <Product />
      </div>
      <div id="campus">
        <Campus />
      </div>
      <div id="advantage">
        <Advantage />
      </div>
      <div id="cooperation">
        <Partner />
      </div>
      <div>
        <Message />
      </div>
      <Teacher />
      <Log />
    </div>
  );
}
